import { Grid } from "@mui/material";
import { useCallback } from "react";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { useDraftDeleteAllMutation } from "@/src-refactor/modules/store/qrtk/services/property-draft/property-draft.qrtk";
import { HCatchServerError } from "@rf-helper/cath-error-server";
import toast from "react-hot-toast";
import useAlert from "@rf-hooks/useAlert";
import { useStatsSlice } from "@/src-refactor/modules/store/redux/stats/stats.slice";

const PropertyDraftDeleteAllButton = () => {
  const [DELETE_ALL_DRAFTS_M] = useDraftDeleteAllMutation();
  const { warningAlert } = useAlert();

  const handleDeleteAll = useCallback(() => {
    warningAlert({
      title: "Eliminar todos los borradores",
      message: "¿Estás seguro de querer eliminar todos los borradores?",
      confirmBtnMessage: "Eliminar",
      declineBtnMessage: "Cancelar"
    }).then(res => {
      if (res.type.confirm) {
        const promise = DELETE_ALL_DRAFTS_M({}).unwrap();
        toast.promise(promise, {
          loading: "Eliminando borradores...",
          success: "Todos los borradores han sido eliminados",
          error: e => HCatchServerError(e)
        });
      }
    });
  }, [DELETE_ALL_DRAFTS_M]);

  const { stats } = useStatsSlice();
  if (!Boolean(stats?.countDrafts)) return null;
  return (
    <Grid item sm={"auto"}>
      <MxButton2
        textColor="white"
        children="Eliminar todos los borradores"
        onClick={handleDeleteAll}
        variant="contained"
        bgColor="error.main"
        testId="create-draft-button"
      />
    </Grid>
  );
};
export default PropertyDraftDeleteAllButton;
